import { useContext } from 'react';
import RequestACallbackContext from './RequestACallbackContext';

export const useRequestACallback = () => useContext(RequestACallbackContext);
